import React from "react";
import { Image } from "react-bootstrap";
import moment from "moment";
import DeletePopup from "../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
import { useSelector } from "react-redux";

export const TableHeadSeating = (props) => {
  return (
    <thead className="sd_table_thead">
      <th className="request-number">
        <p className="font_16_r">Request Type</p>
      </th>
      <th className="total-pax">
        <p className="font_16_r">
          Name /<br />
          Request Number
        </p>
      </th>
      <th className={"location"}>
        <p className="font_16_r">Total PAX</p>
      </th>
      <th className="seating-preference">
        <p className="font_16_r">
          Seating
          <br />
          Preference
        </p>
      </th>
      <th className="action text-center">
        <p className="font_16_r">Action</p>
      </th>
    </thead>
  );
};

export const TableBodySeating = (props) => {
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(props?.dinerInfo?.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let vendorId = JSON.parse(localStorage.getItem("vendorId"));
  let subscriptionId = JSON.parse(localStorage.getItem("subscriptionId"));
  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  const updatedTime = new Date(
    props?.dinerInfo?.wait_time !== undefined
      ? props?.dinerInfo?.wait_time_date
      : props?.dinerInfo?.reservationTime
  );
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime =
    props?.dinerInfo?.wait_time !== undefined
      ? props?.dinerInfo?.wait_time * 60 * 1000
      : 0;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  const seatedTime = new Date(props?.dinerInfo?.seatedTime);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " hh : " + nMinutesSeated + " mins";
  }

  const subscription_id = useSelector(
    (state) => state?.onboarding?.onboard_subscription_details?._id
  );

  return (
    <React.Fragment>
      <tbody className="w-100 seating-dashboard-body-new">
        <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css">
                <tr
                  className={`cursor enGrayBorderBox sd_body_tr ${
                    props &&
                    props?.dinerInfo &&
                    props?.dinerInfo?.userConfirmed === true
                      ? "td_b_g"
                      : "td_b_o"
                  }`}
                  //   onClick={showTr}
                >
                  <td
                    className={
                      // props?.dinerInfo?.isWalkIn === true ||
                      // props?.dinerInfo?.isWalkIn === false
                      props &&
                      props?.dinerInfo &&
                      props?.dinerInfo?.userConfirmed === true
                        ? "td_b_g order-type-Image p-2"
                        : "td_b_o order-type-Image p-2"
                    }
                    style={{ width: "6%" }}
                  >
                    {props?.dinerInfo?.isWalkIn === true &&
                    props?.dinerInfo?.service_type === "SEATING" ? (
                      <Image
                        src={require("../../../assets/images/ActionImages/image/walkin.svg")}
                        alt="Order Type"
                        title="Order Type"
                        width="100%"
                      />
                    ) : null ||
                      (props?.dinerInfo?.isWalkIn === false &&
                        props?.dinerInfo?.service_type === "SEATING") ? (
                      <Image
                        src={require("../../../assets/images/ActionImages/image/waitlist.svg")}
                        alt="Order Type"
                        title="Order Type"
                        width="100%"
                      />
                    ) : null ||
                      props?.dinerInfo?.service_type === "RESERVATION" ? (
                      <Image
                        src={require("../../../assets/images/ActionImages/image/reservation.svg")}
                        alt="Order Type"
                        title="Order Type"
                        width="100%"
                      />
                    ) : null}
                  </td>

                  <td
                    style={{ width: !props?.displayGrid ? "25%" : "20%" }}
                    className="ml-3"
                  >
                    <h4 className="font_20_m">
                      {props?.dinerInfo?.user_details?.name || ""}
                    </h4>
                    <p className="font_12_r">#{props?.dinerInfo?.diner_id}</p>
                  </td>
                  <td
                    style={{ width: !props?.displayGrid ? "15%" : "12%" }}
                    className="p-0"
                  >
                    <div className="total-pax-body">
                      <div className="col d-flex p-0">
                        <div className="total-pax-body-inside">
                          <h4 className="font_24_b">
                            {props?.dinerInfo?.adult_count +
                              props?.dinerInfo?.kids_count}
                          </h4>
                          {/* <p className="total-pax-light-text">PAX</p> */}
                        </div>
                        <div className="total-adult-kids">
                          <div className="display-align">
                            <Image
                              src={require("../../../assets/images/ActionImages/image/adult.svg")}
                              alt="Adult"
                              title="Adult"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props?.dinerInfo?.adult_count}
                            </p>
                          </div>
                          <div className="display-align">
                            <Image
                              src={require("../../../assets/images/ActionImages/image/kids.svg")}
                              alt="Kids"
                              title="Kids"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props?.dinerInfo?.kids_count}
                            </p>
                          </div>
                        </div>
                        <div className="total-highchair-handicapp">
                          {/* {props?.dinerInfo?.high_chair === 0 ? null : ( */}
                          <div className="display-align">
                            <Image
                              src={require("../../../assets/images/ActionImages/image/highchair.svg")}
                              alt="Highchair"
                              title="Highchair"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props?.dinerInfo?.high_chair}
                            </p>
                          </div>
                          {/* )}
                    {props?.dinerInfo?.handicap_chair === 0 ? null : ( */}
                          <div className="display-align">
                            <Image
                              src={require("../../../assets/images/ActionImages/image/handicap.svg")}
                              alt="Handicapped"
                              title="Handicapped"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props?.dinerInfo?.handicap_chair}
                            </p>
                          </div>
                          {/* )} */}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td
                    style={{
                      width: "15%",
                    }}
                    className="p-0"
                  >
                    <h4 className="font_20_m">
                      {props?.dinerInfo?.seating_preference[0]}
                    </h4>
                  </td>

                  <td
                    style={{ width: "39%" }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    <div
                      className={
                        // props?.displayButton === true
                        //   ?
                        "action-section-body d-flex align-items-center justify-content-center f10-500"
                        //   : "action-section-body align-items-center  f10-500"
                      }
                    >
                      <div className="middle-timer">
                        <p className="font_12_r mb-2">Total Wait time</p>
                        <div className="count-down-timer d-flex">
                          <i
                            className="fa fa-hourglass-half mr-3"
                            aria-hidden="true"
                          ></i>
                          <p className="font_16_m">
                            {props?.dinerInfo?.diner_status === "NOTSEATED"
                              ? time_convert(minutes)
                              : seated_time_difference(minutesSeated)}
                          </p>
                        </div>
                        <p className="font_16_r">
                          Status:&nbsp;
                          <span className="font_16_b">
                            {props?.dinerInfo?.diner_status === "NOTSEATED"
                              ? "NOT SEATED"
                              : "SEATED"}
                          </span>
                        </p>
                      </div>
                      {/* <div className="middle-timer ml-2">
                        <div
                          className="seating-status d-flex"
                          style={{
                            backgroundColor: `${
                              props?.dinerInfo?.diner_status === "NOTSEATED"
                                ? "#FFF6DF"
                                : "#E6FFDF"
                            }`,
                          }}
                        >
                          <p
                            className="font_16_m"
                            style={{
                              color: `${
                                props?.dinerInfo?.diner_status === "NOTSEATED"
                                  ? "#E2A200"
                                  : "#25A900"
                              }`,
                            }}
                          >
                            {props?.dinerInfo?.diner_status === "NOTSEATED"
                              ? "Not Seated"
                              : "Seated"}
                          </p>
                        </div>
                      </div> */}

                      <div>
                        <DeletePopup
                          buttonDisplay="seatingCompleted"
                          displayPopup="seatingCompleted"
                          buttonText="Complete"
                          bigText="Request Complete"
                          reasonText="Are you sure to Completed ?"
                          dataSend={props?.dinerInfo}
                          subscription_id={subscription_id}
                          pathAction="HISTORY"
                          adminSendVendorId={vendorId}
                          onSuccess={props.onSuccess}
                          IconButton={require("../../../assets/images/iconButton/Check_green.svg")}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
                {/* {TrDetail.TrDetail && (
                  <tr
                    className="sd_accordion_body"
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    {!props?.displayGrid ? (
                      <TableGridViewLeft
                        onSubmitHandlerAssignTable={onSubmitHandlerAssignTable}
                        subscription_id={
                          props?.actionPerformBy === "ADMIN"
                            ? subscriptionId
                            : props?.subscription_id
                        }
                        tableSelected={props?.tableSelected}
                        dinerInfo={props?.dinerInfo}
                        onCloseModal={onCloseModal}
                        time_convert={time_convert}
                        seated_time_difference={seated_time_difference}
                        minutes={minutes}
                        minutesSeated={minutesSeated}
                        displayCall={props?.displayCall}
                        displaySms={props?.displaySms}
                        displayNotification={props?.displayNotification}
                        displayChat={props?.displayChat}
                        openChatWindow={props?.openChatWindow}
                        displayViewDiner={props?.displayViewDiner}
                        displayEditDiner={props?.displayEditDiner}
                        onClosedAction={onCloseModal}
                      />
                    ) : (
                      <>
                        <td
                          className="sd_accordion_td_1"
                          onClick={(e) => {
                            if (!e) var e = window.event;
                            e.cancelBubble = true;
                            if (e.stopPropagation) e.stopPropagation();
                          }}
                        >
                          <h4 className="font_20_m c_red">More details</h4>

                          <div className="d-flex justify-content-between mt-3 mr-3">
                            {props?.displayCall === true ? (
                              <CallingButtonPopup
                                buttonClass="smallButton"
                                sendData={props?.dinerInfo}
                              />
                            ) : null}
                            {props?.displaySms === true ? (
                              <SendSmsButton
                                dataSend={props?.dinerInfo}
                                buttonClass="smallButton"
                              />
                            ) : null}
                            {props?.displayNotification === true ? (
                              <NotificationButton
                                buttonClass="smallButton"
                                dataSend={props?.dinerInfo}
                              />
                            ) : null}
                            {props?.displayChat === true ? (
                              <ChatWindow
                                data={props?.dinerInfo}
                                text={props?.actionBy}
                              />
                            ) : null}
                            {props?.displayViewDiner === true ? (
                              // <ViewButtonPopup
                              //   dataSend={props?.dinerInfo}
                              //   buttonClass="smallButton"
                              // />
                              <ViewDiner
                                actionByData={props?.actionBy}
                                setEnterTableModalProp={(e) => setTablePopUp()}
                                enterTableModal={enterTableModal}
                                dataSend={props?.dinerInfo}
                                displayData={props?.displayInfo}
                                displayButton="SEATING"
                                viewActionPerformBy={props?.actionPerformBy}
                                viewVendorId={vendorId}
                                subscription_id={
                                  props?.actionPerformBy === "ADMIN"
                                    ? subscriptionId
                                    : props?.subscription_id
                                }
                                socket={props?.socket}
                              />
                            ) : null}
                            {props?.displayEditDiner === true ? (
                              <EditDiner
                                actionByData={props?.actionBy}
                                buttonClass="smallButton"
                                dataSend={props?.dinerInfo}
                                bigText="Edit Diner"
                                displayData={props?.displayInfo}
                                displayButton="SEATING"
                                viewActionPerformBy={props?.actionPerformBy}
                                viewVendorId={vendorId}
                                subscription_id={
                                  props?.actionPerformBy === "ADMIN"
                                    ? subscriptionId
                                    : props?.subscription_id
                                }
                              />
                            ) : null}
                          </div>
                        </td>
                        <td className="sd_accordion_td_2">
                          <h4 className="font_20_m">Track User Location</h4>
                          <LocationReusable
                            dataSend={props?.dinerInfo}
                            socket={props?.socket}
                          />
                        </td>
                        <td className="sd_accordion_td_3">
                          <h4 className="font_20_m">Date & Time</h4>
                          <div className="mt-3">
                            <p className="font_16_r">
                              {props?.dinerInfo?.service_type === "RESERVATION"
                                ? moment(
                                    props?.dinerInfo?.reservationTime
                                  ).format("Do MMM YYYY")
                                : moment(props?.dinerInfo?.createdAt).format(
                                    "Do MMM YYYY"
                                  )}
                            </p>
                            <p className="font_16_r">
                              {props?.dinerInfo?.service_type === "RESERVATION"
                                ? moment(
                                    props?.dinerInfo?.reservationTime
                                  ).format("hh:mm A")
                                : moment(props?.dinerInfo?.createdAt).format(
                                    "hh:mm A"
                                  )}
                            </p>
                          </div>
                        </td>
                        <td className="sd_accordion_td_4">
                          <h4 className="font_20_m">Table / Room No</h4>
                          <div className="mt-3">
                            <p className="font_16_r">
                              Room no. -{" "}
                              {props?.dinerInfo?.room_number === null && undefined
                                ? ""
                                : props?.dinerInfo?.room_number}
                            </p>
                            <p className="font_16_r">
                              Table no. -{" "}
                              {props?.dinerInfo?.table_number === null &&
                              undefined
                                ? ""
                                : props?.dinerInfo?.table_number}
                            </p>
                          </div>
                        </td>
                        <td className="sd_accordion_td_5">
                          <h4 className="font_20_m">Special Occasion</h4>
                          <div className="d-flex mt-3">
                            <p
                              className="font_16_r"
                              style={{ wordBreak: "break-word" }}
                            >
                              {props?.dinerInfo?.occasion}
                              {props?.dinerInfo?.occasion.length > 65 ? (
                                <span className="c_orange">&nbsp;see more</span>
                              ) : (
                                ""
                              )}
                            </p>
                          </div>
                        </td>
                        <td className="sd_accordion_td_6">
                          <h4 className="font_20_m">Status</h4>
                          <div className="d-flex mt-3">
                            <div
                              className={`${
                                props?.dinerInfo?.diner_status === "NOTSEATED"
                                  ? "b_c_orange"
                                  : props?.dinerInfo?.diner_status === "SEATED"
                                  ? "b_c_light_green"
                                  : props?.dinerInfo?.diner_status ===
                                      "CANCELLED" ||
                                    props?.dinerInfo?.diner_status === "REJECTED"
                                  ? "b_c_red"
                                  : props?.dinerInfo?.diner_status === "COMPLETED"
                                  ? "b_c_green"
                                  : "b_c_orange"
                              } status_blink_box`}
                            ></div>
                            <p className="font_16_m">
                              {props?.dinerInfo?.diner_status}
                            </p>
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                )} */}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};
